<template>
  <div>

    <!-- 文件选择 -->
    <div style="width: 100%;overflow-x: scroll;">

      <input style="visibility: hidden;" type="file" accept="video/*" @change="handleFileChange" ref="fileInput">
      <div style="display: flex; ">
        <!-- 视频播放器 -->
        <div v-for="(item, index) in videoUrls" class="video-container" :key="index">
          <i class="el-icon-circle-close" @click.stop="handleDelete(index)" v-if="!disabled"></i>
          <div @click=" videoUrl = item, videoShow = true">
            <video ref="videoPlayer" :src="item" controls>
            </video>
          </div>

        </div>
        <div v-if="!disabled" @click="triggerFileInput"
          style="height: 150px;width: 150px;display: flex;justify-content: center;align-items: center;border: 1px dotted lightgray; margin-top: 20px;flex-shrink: 0;">
          +
        </div>

      </div>

    </div>

    <div class="video_preview" v-if="videoShow">

      <div class="video_close" @click="videoShow = false">
        <i class="el-icon-close" />
      </div>
      <video style="min-width: 300px;min-height: 300px;" ref="videoPlayer" :src="videoUrl" controls>
      </video>
      <!-- <el-button type="primary" >截图</el-button> -->
      <!-- <img src="@/assets/images/jietu.png" alt="" style="height: 60px;width: 60px;margin: 90px 30px;cursor: pointer;"
        @click="captureFrame"> -->
      <!-- <canvas ref="canvas"
        :style="{ height: canvasHeight, width: canvasWidth, marginLeft: '25px', maxWidth: '300px', maxHeight: '300px' }"></canvas> -->
      <canvas ref="canvas" style="display: none;"></canvas>

    </div>





  </div>
</template>

<script>
import environments from "@/config/url";
const uploadUrl = environments[process.env.VUE_APP_BASE_URL].uploadBaseUrl;
import axios from "axios";
import { encryptByDES } from "@/utils/3DES";

export default {
  name: 'VideoScreenshot',
  props: {
    videos: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadUrl,
      videoUrl: null,
      videoUrls: [],
      serverVideoUrls: [],
      videoShow: false,
      videoDuration: 0,
      canvasWidth: 0,
      canvasHeight: 0,
      headers: {
        'Content-Type': 'multipart/form-data',
        'channel': 'platformPc',
        'ACCESS_TOKEN': localStorage.getItem('token'),
        'TOKEN': encryptByDES(encryptByDES((new Date().getTime()).toString(), '63e42c2444e94c1ebca21d30d2aa39a5'), localStorage.getItem('token') || '')
      }
    }
  },
  watch: {
    // 监听数组变化
    serverVideoUrls(newVal, oldVal) {
      this.$emit('getServerVideoUrls', this.serverVideoUrls);
    },
    videos(newVal, oldVal) {
      this.videoUrls = this.videos
      this.serverVideoUrls = this.videos
    }
  },
  created() {

  },
  methods: {
    handleDelete(index) {
      this.videoUrls = this.videoUrls.filter((_, i) => i !== index);
      this.serverVideoUrls = this.serverVideoUrls.filter((_, i) => i !== index);
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    // 处理文件选择
    handleFileChange(event) {
      const file = event.target.files[0]
      if (!file) return

      const formData = new FormData();
      formData.append("file", file);
      axios
        .post(uploadUrl, formData, {
          headers: this.headers,
        })
        .then((response) => {
          this.$message.success('视频上传成功')
          // 创建视频URL
          const localVideoUrl = URL.createObjectURL(file)
          this.videoUrls = [...this.videoUrls, localVideoUrl]
          this.serverVideoUrls = [...this.serverVideoUrls, response.data.orgUrl]
          console.log('this.videoUrls', this.videoUrls);
          console.log('this.serverVideoUrls', this.serverVideoUrls);

        })
        .catch((error) => {
          console.error("文件上传失败", error);
        });

      // 重置文件输入，允许重复选择同一文件
      this.$refs.fileInput.value = ''
    },



    // 捕获当前帧
    captureFrame() {
      const video = this.$refs.videoPlayer
      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')

      // 绘制当前视频帧到canvas
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height)


      // 缩小显示尺寸（仅视觉效果，不影响实际捕获的图像）
      this.canvasWidth = (video.videoWidth * 0.6) + 'px';
      this.canvasHeight = (video.videoHeight * 0.6) + 'px';

      // 正确将Canvas内容转换为Blob
      canvas.toBlob((blob) => {
        if (blob) {
          const formData = new FormData();

          // 将Blob转换为File对象并指定文件名
          const fileName = `screenshot-${new Date().getTime()}.png`;
          const file = new File([blob], fileName, { type: 'image/png' });

          formData.append('file', file);
          formData.append('filename', fileName);
          console.log('formData', formData);

          axios
            .post(uploadUrl, formData, {
              headers: this.headers,
            })
            .then((response) => {
              this.$message.success('截图并上传图片成功,请在下面照片列查看')
              this.$emit('getServerImageUrl', response.data.orgUrl);

            })
            .catch((error) => {
              this.$message.error("文件上传失败", error);
            });
        } else {
          console.error('无法创建Blob对象');
        }
      }, 'image/png'); // 可以指定格式，如'image/jpeg'，并可添加质量参数


    },




  },
  beforeDestroy() {
    // 组件销毁时释放视频URL
    if (this.videoUrl) {
      URL.revokeObjectURL(this.videoUrl)
    }
  }
}
</script>

<style scoped lang="scss">
input[type="file"]::-webkit-file-upload-button {
  visibility: hidden;
}




.video-container {
  flex-shrink: 0;
  /* 禁止收缩 */
  width: 150px;
  /* 固定宽度（与视频宽度一致） */
  margin-right: 20px;
}

.video-container video {
  height: 150px;
  width: 150px;
  background: #000;
  margin: 5px 15px;
}

.controls {
  margin: 15px 0;
}

.controls button {
  margin-right: 10px;
  padding: 8px 15px;
  background: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.controls button:hover {
  background: #369f6e;
}

.screenshot-result {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.screenshot-result img {
  max-width: 100%;
  margin: 15px 0;
  display: block;
  border: 1px solid #ddd;
}

.video_preview {
  /* 原有样式保持不变 */

  .video_controls {
    position: absolute;
    top: 40px;
    left: 40px;
    z-index: 1;

    .capture-btn {
      background-color: #0981FF;
      color: white;
      border: none;


    }
  }

  video {
    /* 原有样式保持不变 */
    max-width: 90%;
    max-height: 80%;
  }
}

.el-img-upload>div {
  display: flex;

  /deep/.el-upload {
    width: 148px;
    height: 148px;
  }
}

.video_preview {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, .5);
  left: 0;
  top: 0;
  z-index: 99999999999999999;
  display: flex;
  justify-content: center;
  align-items: center;

  .video_close {
    position: absolute;
    top: 40px;
    right: 40px;
    width: 40px;
    height: 40px;
    font-size: 24px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    background-color: #606266;
    border-radius: 50%;
    cursor: pointer;
  }

  video {
    display: block;
    //margin: 60px auto;
    width: auto;
    height: 85%;
    object-fit: cover;
  }
}

.hide-upload {
  /deep/.el-upload {
    display: none;
  }
}
</style>